export default __webpack_public_path__ + "SolutionIcon6.becc2cd.png";